import {Component, EventEmitter, Input, OnDestroy, OnInit, Output, TemplateRef, ViewChild} from '@angular/core';
import {MemberModel} from '../../../models/user.model';
import {ModalService} from '../../../services/modal/modal.service';
import {AlertService} from '../../../services/notify/alert.service';
import {HelpersService} from '../../../services/helpers.service';
import {ActivatedRoute, Router} from '@angular/router';
import {TaskModel} from '../../../models/task.model';
import {CrmService} from '../../../services/api/crm.service';
import {TaskServiceService} from '../../../services/task-service.service';
import {BoardGroupModel, BoardTableModel, TaskBoardModel, TaskTypesModel} from '../../../models/tasktable.model';
import {NgbModalRef} from '@ng-bootstrap/ng-bootstrap/modal/modal-ref';
import {MemberService} from '../../../services/member.service';
import {PaginationModel} from '../../../models/file-table.model';
import {filter, Subscription} from 'rxjs';
import {TranslateService} from '@ngx-translate/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { AppContentDialogComponentMT } from '../../material/content-dialog/app-content-dialog.component';
import { FormControl, Validators } from '@angular/forms';
import { AppBoardMngtFormComponent } from '../../../controllers/tasks/forms/board-mngt-form/board-mngt-form';
import { AppTaskMngtFormComponent } from '../../../controllers/tasks/forms/task-mngt-form/task-mngt-form';

@Component({
    selector: 'app-component-button-create-task',
    templateUrl: './button-create-task.component.html',
    styleUrls: ['./button-create-task.component.scss'],
})
export class ButtonCreateTaskComponent implements OnInit, OnDestroy {
    @Input() isShowBoardButton: boolean;
    @Input() isShowTaskButton = false;
    @Input() isShowRightButtons = false;
    @Input() viewType: string;

    @ViewChild('taskView') public viewTask: TemplateRef<any>;
    @ViewChild('createDashView') public createDashView: TemplateRef<any>;

    @Output() eminOnCreateTask: EventEmitter<TaskModel> = new EventEmitter<TaskModel>();
    @Output() eminOnCreateDashboard: EventEmitter<any> = new EventEmitter<any>();
    @Output() emitChangeDesk: EventEmitter<string | {}> = new EventEmitter<string | {}>();
    @Output() emitAddRange: EventEmitter<any> = new EventEmitter<any>();
    @Output() emitSaveSettings: EventEmitter<any> = new EventEmitter<any>();
    
    description: string;
    board: string;

    public dashes: BoardTableModel[];
    public groups: BoardGroupModel[];
    selectedGroup: BoardGroupModel;
    selectedGroupId: string;
    isShowIcons = false;
    isShowSettingBoardGear = false;

    selectedDash: TaskBoardModel | BoardTableModel = null;

    changeBoard: TaskBoardModel;
    selectedType: TaskTypesModel;

    alias: string;
    currentMember: MemberModel;

    icons = {
        selected: '',
        all: [
            'bi bi-alarm',
            'bi bi-archive',
            'bi bi-at',
            'bi bi-asterisk',
            'bi bi-bar-chart',
            'bi bi-bar-chart-steps',
            'bi bi-bell',
            'bi bi-box-seam',
            'bi bi-bricks',
            'bi bi-briefcase',
            'bi bi-buildings',
            'bi bi-calendar-date',
            'bi bi-camera',
            'bi bi-cash-stack',
            'bi bi-chat-dots',
            'bi bi-check2-all',
            'bi bi-easel',
            'bi bi-pen',
        ],
    };
    firstFocus = false;

    taskAlias: string;

    isLockButton = false;

    isSubtask = false;

    subscribe: Subscription;

    public dashNameFC = new FormControl('')
    private dialogRef:MatDialogRef<any>|undefined = undefined
    constructor(
        private dialog : MatDialog,
        protected modalService: ModalService,
        protected crmService: CrmService,
        protected alertService: AlertService,
        public helper: HelpersService,
        protected router: Router,
        protected taskService: TaskServiceService,
        protected actRouter: ActivatedRoute,
        protected memberService: MemberService,
        private translate: TranslateService
    ) {
    }

    ngOnInit(): void {
        this.dashNameFC.addValidators([Validators.required])
        this.actRouter.params.subscribe(res => {
            this.alias = res.alias;
            if (res.id && !res.alias) {
                this.isSubtask = true;
                this.alias = res.id.split('-')[0];
            }
            this.board = document.location.pathname.split('/').reverse()[this.alias ? 1 : 0];
            this.memberService.getCurrentMember().then(member => {
                this.isShowTaskButton = member.project_setting.is_project_admin;
                this.isShowSettingBoardGear = member.project_setting.is_project_admin;
                this.isShowBoardButton = (this.isShowBoardButton && member.project_setting.is_project_admin);

                if (this.alias) {
                    this.taskService.getBoard(this.alias).then(result => {
                        this.selectedDash = result.board;
                        this.isShowTaskButton = this.selectedDash.rights.is_create_new_task === 'allowed' ||
                            member.project_setting.is_project_admin;
                        this.isShowSettingBoardGear = this.selectedDash.rights.is_edit_settings === 'allowed' ||
                            member.project_setting.is_project_admin;
                    });
                } else {
                    this.taskService.getAllBoards(false).then(result => {
                        this.dashes = result.boards.filter(onlyBoard =>
                            onlyBoard.rights && onlyBoard.rights.is_create_new_task);
                        this.groups = result.groups;

                        result.groups.map((x: BoardGroupModel) => {
                            const boardsWithPermissions = x.boards.filter(groupBoard =>
                                groupBoard.rights && groupBoard.rights.is_create_new_task);
                            this.dashes = this.dashes.concat(boardsWithPermissions);
                        });

                        this.isShowTaskButton = !!this.dashes.length;
                    });
                }
            });
        });

        this.subscribe = this.taskService.eminOnOpenCreateBoardModal.subscribe(res => {
            this.selectedGroup = this.groups.filter(x => x.id === res)[0];
            this.selectedGroupId = res.toString();

            this.modalService.openTemplateModal(this.createDashView);
        });
    }

    ngOnDestroy(): void {
        this.subscribe.unsubscribe();
    }
    openDialog(content: TemplateRef<any>,minWidth?:number,minHeight?:number) {
      this.dialogRef = this.dialog.open(AppContentDialogComponentMT,{
            panelClass:'file-toolbar-dialog',minHeight:minHeight,minWidth:minWidth, maxHeight:'95vh'
        })
      this.dialogRef.componentInstance.templateRef = content
    }
    onOpenCreateTaskModal(content: TemplateRef<any>): void {
        this.selectedType = null;
        this.changeBoard = null;
        this.description = '';
        if (!this.alias) {
            if (this.dashes) {
                this.modalService.openTemplateModal(content);
            }
        } else {
            this.changeBoard = this.selectedDash as TaskBoardModel;
            this.selectedType = (this.selectedDash as TaskBoardModel).task_types[0];
            if (this.selectedDash) {
                this.modalService.openTemplateModal(content);
            }
        }
    }

    onOpenModal(content: TemplateRef<any>, size?: string): void {
        this.selectedGroupId = null;
        this.modalService.openTemplateModal(content, size);
    }
    onOpenCreateDashForm() {
        let ref = this.dialog.open(AppBoardMngtFormComponent)
        ref.componentInstance.formMode = 'Create'
        ref.componentInstance.boardGroups = this.groups
        ref.componentInstance.aliasesTaken = this.dashes.map(el=>el.alias)
        this.subscribe.add(ref.afterClosed().subscribe((res:any)=>this.eminOnCreateDashboard.emit(res?.board)))
    }
    onOpenCreateTaskForm() {
        let ref = this.dialog.open(AppTaskMngtFormComponent)
        if (this.alias) {
            ref.componentInstance.boards = [(this.selectedDash as unknown as TaskBoardModel)]

        } else {
            ref.componentInstance.boards = (this.dashes.sort((a,b)=>a.name > b.name? 1 : -1) as unknown as TaskBoardModel[]);
        }
        this.subscribe.add(ref.afterClosed().pipe(filter(task=>task?.task_alias)).subscribe(task=>{
            this.eminOnCreateTask.emit(task);
            if (!this.alias) {
                this.taskAlias = task.task_alias;
                setTimeout(() => {
                    this.onOpenModal(this.viewTask, 'xl');
                });
            }
            if (this.isSubtask) {
                this.taskAlias = task.task_alias;
                setTimeout(() => {
                    this.onOpenModal(this.viewTask, 'xl');
                });
            }
        }))
    }
    onCreateTask(modal: NgbModalRef, name: string): void {
        if (!name) {
            return this.alertService.setAlert(this.translate.instant('ALERTS.CREATE_TASK_NAME'), 'blue');
        }
        if (!this.selectedDash) {
            return this.alertService.setAlert(this.translate.instant('ALERTS.CREATE_TASK_BP'), 'blue');
        }
        if (!this.selectedType) {
            return this.alertService.setAlert(this.translate.instant('CREATE_TASK_TYPE'), 'blue');
        }

        const taskData = {
            title: name,
            content: this.description,
            board_alias: this.selectedDash.alias,
            task_type_id: this.selectedType.id,
        };
        this.isLockButton = true;

        this.crmService.createTask(taskData).subscribe({
            next: data => {
                modal.close();
                this.eminOnCreateTask.emit(data.task);
                this.alertService.setAlert(this.translate.instant('ALERTS.SUCCESS'), 'nd_color');
                this.firstFocus = false;
                this.changeBoard = null;
                this.selectedType = null;
                if (!this.alias) {
                    this.selectedDash = null;
                    this.taskAlias = data.task.task_alias;
                    setTimeout(() => {
                        this.onOpenModal(this.viewTask, 'xl');
                    });
                }
                if (this.isSubtask) {
                    this.taskAlias = data.task.task_alias;
                    setTimeout(() => {
                        this.onOpenModal(this.viewTask, 'xl');
                    });
                }

                this.isLockButton = false;
            }, error: error => {
                this.alertService.setAlert(error.message, 'blue');
                this.isLockButton = false;
            },
        });
    }

/*     onCreateDash(
        dashName: string,
        dashAlias: string,
        dashDescription: string,
        isNeedToCreateStatuses: boolean,
        modal: NgbModalRef
    ): void {
        if (!dashName) {
            return this.alertService.setAlert(this.translate.instant('ALERTS.CREATE_BOARD_NAME'), 'blue');
        }
        if (!dashAlias) {
            return this.alertService.setAlert(this.translate.instant('ALERTS.CREATE_BOARD_ALIAS'), 'blue');
        }

        const data = {
            name: dashName,
            alias: dashAlias,
            icon: this.icons.selected,
            group_id: this.selectedGroupId ? Number(this.selectedGroupId) : null,
            description: dashDescription,
            need_to_create_statuses: isNeedToCreateStatuses,
        };
        this.isLockButton = true;

        this.crmService.createDashboard(data).subscribe({
            next: res => {
                this.selectedGroup = undefined;
                this.eminOnCreateDashboard.emit(res.task_board);
                modal.close();
                this.alertService.setAlert(this.translate.instant('ALERTS.SUCCESS'), 'nd_color');
                this.isLockButton = false;
            }, error: error => {
                this.alertService.setAlert(error.message, 'blue');
                this.isLockButton = false;
            },
        });
    }
 */
    selectBoard(board: BoardTableModel | TaskBoardModel): void {
        this.taskService.getBoard(board.alias, true).then(res => {
            this.changeBoard = res.board;
            this.selectedType = this.changeBoard.task_types[0];
        });
    }

    closeTaskModal(): void {
        if (!this.alias) {
            this.selectedDash = null;
        }
    }

    openBoardLife(): void {
        const pagination: PaginationModel = {
            limit: 20,
            current_page: 1,
        };
        this.crmService.getBoardLife(this.alias, pagination).subscribe({
            next: res => {
                this.emitChangeDesk.emit({type: 'logs', logs: res});
            }, error: err => {
                this.alertService.setAlert(err.message, 'blue');
            },
        });
    }

    cleanHash(): void {
        if (window.location.hash) {
            window.location.hash = '';
        }
    }

    onCreateGroup(): void {
        this.isLockButton = true
        if (!this.dashNameFC?.value) {
            return
        }
        this.crmService.createDashboardGroup(this.dashNameFC.value).subscribe({
            next: res => {
                this.taskService.eminOnCreateBoardGroup.emit(res.group);
                this.groups.push(res.group);
                this.isLockButton = false
                this.dialogRef?.close();
                this.alertService.setAlert(this.translate.instant('ALERTS.SUCCESS'), 'nd_color');
            }, error: err => {
                this.isLockButton = false
                this.alertService.setAlert(err.message, 'blue');
            }
        });
    }
}

